import { ImportMap } from './types.js';

export const importMapOverride: ImportMap = {
  imports: {},
};
